import { LineSegments, Mesh, MeshBasicMaterial, Object3D, SphereGeometry, Vector3 } from 'three';
import { TextValueVO } from '@shared/vo/meta-element.vo';
import { LabelElement } from '@3d-scene/layer/elements/label-element';
import { ILayerElement } from '@3d-scene/layer/elements/i-layer-element';
import { DimensionUtils } from '../util/dimension.utils';

export class PointerLabelElement extends Object3D implements ILayerElement {
  public static readonly LINE_COLOR: number = 0x000000;
  public static readonly LINE_THICKNESS: number = 0.8;
  public static readonly LINE_OFFSET: number = 130;
  public static readonly POINT_RADIUS: number = 17;
  public static readonly LABEL_ROTATION: Vector3 = new Vector3(-90, 0, -90);

  public layerElementType: string = 'ILayerElement';

  protected labelPosition: Vector3;
  protected articlePosition: Vector3;
  protected labelLength: number;
  protected labelWidth: number = 50;
  protected text: TextValueVO;

  constructor(position: Vector3, articlePosition: Vector3, text: TextValueVO, labelLength: number, drawPointer: boolean = false) {
    super();
    this.labelPosition = position;
    this.articlePosition = articlePosition;
    this.text = text;
    this.labelLength = labelLength;

    this.createText(text);

    if (drawPointer) {
      this.createLine();
      this.drawCircle(articlePosition, PointerLabelElement.POINT_RADIUS);
    }
  }

  protected createText(text: TextValueVO): void {
    const label: LabelElement = new LabelElement(text, LabelElement.DEFAULT_FONT_SIZE, PointerLabelElement.LABEL_ROTATION,
      this.labelLength);
    label.position.set(this.labelPosition.x, this.labelPosition.y, this.labelPosition.z);
    this.add(label);
  }

  protected createLine(): void {
    const lines: Object3D = new Object3D();
    const startPoint: Vector3 = this.labelPosition.add(new Vector3(0, 0, PointerLabelElement.LINE_OFFSET));
    const endPoint: Vector3 = this.articlePosition;
    const lineTo: LineSegments = DimensionUtils.createLineSegment(startPoint, endPoint, PointerLabelElement.LINE_COLOR);
    lines.add(lineTo);
    this.add(lines);
  }

  protected drawCircle(position: Vector3, radius: number): void {
    const circle: Mesh = new Mesh(new SphereGeometry(radius, 32, 32));
    const circlePosition: Vector3 = position.add(new Vector3(0, 0, -radius / 2));
    circle.position.set(circlePosition.x, circlePosition.y, circlePosition.z);
    circle.material = new MeshBasicMaterial({color: PointerLabelElement.LINE_COLOR});
    this.add(circle);
  }
}
